import React from 'react';
import PromosCollects from '@screens/players/player.details.tabs/promos/player.promos.collects';
import PromosTasks from '@screens/players/player.details.tabs/promos/player.promos.tasks';
import { PlayerDataProps } from '@screens/players/types/player.data.props';

const Promos = ({ player }: PlayerDataProps) => {
  return (
    <>
      <PromosCollects player={player} />
      <PromosTasks player={player} />
    </>
  );
};

export default Promos;
